import axios from 'axios';
import UserAuthKey from '../../../../components/Common/UserAuthKey';
import { setTechnicianList, setTechnicianInventory, setTechnicianInventoryHistory } from '../../../../Redux/services/serviceSlice';
import { setUserData } from '../../../../Redux/user/userSlice';

const apiUrl = process.env.REACT_APP_OMS_NEST_API;
// const apiUrl = 'http://localhost:3008/rest/v1';
const apiOMSUrl = process.env.REACT_APP_OMS_API;

export const fetchTechniciansList = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'GET',
    url: `${apiUrl}/order/get-technicians-list`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json', 
    },
    params: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    dispatch(setTechnicianList(response?.data));
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      dispatch(setTechnicianList([]));
    }
  }
};

export const saveTechnician = async ({ data, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}/order/save-technician`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: data,
  };
  try {
    const response = await axios(config);
    fetchTechniciansList({ params: {}, dispatch });
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      throw error;
    }
  }
};

export const fetchTechnicianInventory = async ({ data, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiOMSUrl}/v1/service-order/item-list`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json', 
    },
    data: data,
  };
  try {
    const response = await axios(config);
    dispatch(setTechnicianInventory(response?.data));
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      dispatch(setTechnicianInventory([]));
    }
  }
};

export const fetchTechnicianInventoryHistory = async ({ data, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}/order/get-technician-item-history`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json', 
    },
    data: data,
  };
  try {
    const response = await axios(config);
    dispatch(setTechnicianInventoryHistory(response?.data));
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      dispatch(setTechnicianInventoryHistory([]));
    }
  }
};
